export default "__VITE_ASSET__29ab0cd0__"